import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusTocHeaderOverline], campus-toc-header-overline',
})
export class TocHeaderOverlineDirective {
  @HostBinding('class')
  defaultClasses = ['label-overline', 'text-opacity-medium', 'uppercase'];
}
